/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { DictionaryItem } from '@gh/common-shared';
import { LeadBoardFormState } from '../../lead-board-form.service';
import { getLeadBoardColumnId } from '../../lead-board.state';

@Component({
  standalone: false,
  selector: 'gh-lead-board-panel',
  templateUrl: 'lead-board-panel.component.html',
  styleUrls: ['lead-board-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LeadBoardPanelComponent {
  @Input() stages: DictionaryItem<any>[];
  @Input() priority: DictionaryItem<any>;

  constructor(public form: LeadBoardFormState) {
  }

  getZoneId(priority: number, stage: number): string {
    return getLeadBoardColumnId(priority, stage);
  }
}
